import { faPaperPlane, faRocket, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Container, Pagination, Row, Table } from "react-bootstrap";
import { AppAuthStateProps } from '../../types/propTypes';

import { callLLMCohort } from '../../amplify/api/llm-cohort';
import { isDemoUser } from '../../utils/demo';
import PersonalIdentifier from '../common/PersonalIdentifier';
import { ExpandingTextarea } from '../input/ExpandingTextArea';
import './Cohort.css';
import { FilterMinMax } from './FilterMinMax';
import { FilterMultiSelect } from './FilterMultiSelect';

const EXCLUDE_COLUMNS = new Set(["internal_csn", "internal_mrn", "full_count", "available_waveforms"]);
const NUM_RESULTS_PER_PAGE = 30;

export const Cohort = (props: AppAuthStateProps) => {

    const scrollCheckpointRef = useRef<HTMLDivElement>(null);

    const [isLoading, setIsLoading] = useState<any>(false);

    const [filterOptions, setFilterOptions]: any = useState<any>({
        "Gender": [],
        "Age": {
            "min": null,
            "max": null,
        },
        // "Roomed Time": {
        //     "start_time": null,
        //     "end_time": null,
        // },
    });

    const [showFilterGender, setShowFilterGender] = useState<any>(false);
    const [showFilterAge, setShowFilterAge] = useState<any>(false);
    const [showFilterRoomedTime, setShowFilterRoomedTime] = useState<any>(false);

    const [query, setQuery] = useState<any>("");
    const [text, setText] = useState<any>("");
    const [sql, setSql] = useState<any>("");
    const [error, setError] = useState<any>("");
    const [queryId, setQueryId] = useState<any>("");
    // const [totalRows, setTotalRows] = useState<any>(0);
    const [header, setHeader] = useState<any>([]);
    const [rows, setRows] = useState<any>([]);
    const [activePageNumber, setActivePageNumber] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalNumberOfResults, setTotalNumberOfResults] = useState<number>(0);
    const [downloadLink, setDownloadLink] = useState<any>("");
    const [options, setOptions] = useState<any>({
        "Gender": {
            "type": "multiselect",
            "options": {
                "Male": "M",
                "Female": "F",
                "Unidentified": "U",
            },
        },
        "Age": {
            "type": "minmax",
            "options": {
            },
        },
    });
    const [selectedOptions, setSelectedOptions] = useState<any>({
        "Gender": {
            "selected": [],
        },
        "Age": {
            "min": "",
            "max": ""
        },
        // "Roomed Time": {
        //     "min": "",
        //     "max": ""
        // },
    });


    useEffect(() => {
        setIsLoading(true);
        callLLMCohort("", [], activePageNumber, "").then((response: any) => {
            const output = response;

            setRows(output.output);
            setHeader(output.header);
            setSql(output.sql_query);
            setIsLoading(false);
            scrollCheckpointRef.current?.scrollIntoView({ behavior: 'smooth' })
        }).catch((err: any) => {
            console.error(err);
            setIsLoading(false);
            setError(err);
        })
    }, []);

    useEffect(() => {
        console.log("ROWS is")
        console.log(rows)
        if (rows.length > 0) {
            const total = rows[0][rows[0].length - 1];
            const totalPages = Math.ceil(total / NUM_RESULTS_PER_PAGE);
            setTotalPages(totalPages);
            setTotalNumberOfResults(total);
        } else {
            setTotalPages(0);
            setTotalNumberOfResults(0);
        }
    }, [rows]);

    const updateFilterOptions = (option: string, val: any) => {
        setFilterOptions({
            ...filterOptions,
            [option]: val,
        });
    }

    const resetQuery = () => {
        setText("");
        setQuery("");
        setSql("");
        setHeader([]);
        setRows([]);
    }

    const sampleQuery = (sample: string) => {
        setText("");
        setSql("");
        setHeader([]);
        setRows([]);
        send(sample, 1, "");
    }

    const sendChat = (e?: any) => {
        const prompt = `${text}`;

        if (e && (e.key !== 'Enter' || e.shiftKey)) {
            return;
        }

        // Removes leading/trailing line breaks
        setText((prev: any) => prev.replace(/^\s+|\s+$/g, ''))
        setActivePageNumber(1);

        send(prompt, 1, "");
    }

    const send = (prompt: any, pageNum: number, inputSql: string) => {
        setIsLoading(true);
        setQuery(prompt);

        const filters: any = [];
        if (filterOptions["Gender"].length > 0) {
            filters.push({
                "col": "gender",
                "filter_type": "in",
                "vals": filterOptions["Gender"],
            });
        }
        if (filterOptions["Age"].min || filterOptions["Age"].max) {
            filters.push({
                "col": "age",
                "filter_type": "between",
                "min": filterOptions["Age"]["min"],
                "max": filterOptions["Age"]["max"],
            });
        }

        let inputPrompt = prompt;

        console.log(`Calling with prompt: ${inputPrompt}`)

        callLLMCohort(inputPrompt, filters, pageNum, inputSql).then((response: any) => {
            const output = response;
            setText(inputPrompt);
            setRows(output.output);
            setHeader(output.header);
            setSql(output.sql_query);
            setIsLoading(false);
            scrollCheckpointRef.current?.scrollIntoView({ behavior: 'smooth' })
        }).catch((err: any) => {
            console.error(err);
            setText(inputPrompt);
            setIsLoading(false);
            setError(err);
        })
    };

    const range = (start: number, stop: number, step: number) => {
        if (typeof stop == 'undefined') {
            // one param defined
            stop = start;
            start = 0;
        }
    
        if (typeof step == 'undefined') {
            step = 1;
        }
    
        if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
            return [];
        }
    
        var result = [];
        for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
            result.push(i);
        }
    
        return result;
    };

    const pageUpdate = (nextPageInput: number) => {
        let nextPage = nextPageInput;
        nextPage = Math.min(totalPages, nextPage);
        nextPage = Math.max(1, nextPage);
        setActivePageNumber(nextPage);
        send(query, activePageNumber, sql);
    }

    const titleCase = (s: any) => {
        return s.replace (/^[-_]*(.)/, (_: any, c: any) => c.toUpperCase())       // Initial char (after -/_)
        .replace (/[-_]+(.)/g, (_: any, c: any) => ' ' + c.toUpperCase()) // First char after each -/_
    }


    return (
        <>
            <Container style={{paddingTop: isDemoUser(props.user) ? '143px' : '64px', paddingLeft: '32px', paddingRight: '32px'}}>
                <Row>
                    <Col>
                        <h4>Stanford Patient Explorer</h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="population-input">
                            <ExpandingTextarea setText={setText} text={text} sendChat={sendChat} placeholder={"Describe the population you are looking for or use a filter below"} isDisabled={false} />

                            <div className="send-input">
                                {
                                    query ? (
                                        <Button variant="link" size='sm' className="position-relative bottom-0" onClick={() => resetQuery()}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </Button>
                                    ) : (
                                        <Button variant="link" size='sm' className="position-relative bottom-0 assistant-send" onClick={() => sendChat()}>
                                            <FontAwesomeIcon icon={faPaperPlane} />
                                        </Button>
                                    )
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row style={{marginTop: '8px'}}>
                    <Col>
                        <FilterMinMax
                            showFilter={showFilterAge}
                            setShowFilter={setShowFilterAge}
                            filterMinMaxOptions={filterOptions["Age"]}
                            option="Age"
                            updateFilterOptions={updateFilterOptions}
                        />
                        <FilterMultiSelect
                            showFilter={showFilterGender}
                            setShowFilter={setShowFilterGender}
                            selectedItems={filterOptions["Gender"]}
                            option="Gender"
                            updateFilterOptions={updateFilterOptions}
                            availableItems={["M", "F", "U"]}
                        />
                        {/* <FilterDate
                            showFilter={showFilterRoomedTime}
                            setShowFilter={setShowFilterRoomedTime}
                            filterDateOptions={filterOptions["Roomed Time"]}
                            option="Roomed Time"
                            updateFilterOptions={updateFilterOptions}
                        /> */}
                    </Col>
                </Row>
                {
                    (!query && !isLoading) && (
                        <Row style={{marginTop: '24px'}}>
                            <Col md={4}>
                                <Card className="cohort-sample-query" onClick={() => sampleQuery("Show all visits where the patient was older than 80")}>
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <strong>Show all visits</strong> where the patient was older than 80
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="cohort-sample-query" onClick={() => sampleQuery("Find me all male patients who have taken an antibiotic")}>
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <strong>Find me all</strong> male patients who have taken an antibiotic
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {/* <Col md={4}>
                                <Card className="cohort-sample-query">
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <strong>Retrieve all visits</strong> with a chief complaint of SOB and was administered an IV bolus
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className="cohort-sample-query">
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <strong>Filter for visits</strong> where the patient heart rate increased over their visit
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col> */}
                        </Row>
                    ) 
                }
            </Container>
            {
                !isLoading && rows.length > 0 ? (
                <Container style={{paddingTop: '16px', paddingLeft: '32px', paddingRight: '32px'}}>
                    <Row>
                        <Col md={9}>
                            <p>Found <strong>{totalNumberOfResults}</strong> patient visits</p>
                        </Col>
                        {/* <Col md={3} className="text-right">
                            {downloadLink && (
                                <a href={downloadLink} download="cohort.json" target='_blank'>
                                    <Button variant="primary" size="sm">
                                        Download
                                    </Button>
                                </a>
                            )}
                        </Col> */}
                    </Row>
        
                        <div style={{ overflowX: 'scroll' }}>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        {
                                            header.map((h: any, idx: number) => {
                                                if (EXCLUDE_COLUMNS.has(header[idx])) {
                                                    return <></>
                                                } else {
                                                    return (
                                                        <th key={h}>{titleCase(h)}</th>
                                                    )
                                                }
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        rows.map((row: any) => (
                                            <tr key={row && row.length > 0 ? row[0] : ""}>
                                                {
                                                    row.map((val: any, idx: number) => {
                                                        if (EXCLUDE_COLUMNS.has(header[idx])) {
                                                            return (
                                                                <></>
                                                            )
                                                        } else if (header[idx] === "csn") {
                                                            let internalCsnColIndex = header.indexOf("internal_csn");
                                                            return (
                                                                <td><a href={`/dashboard/${row[internalCsnColIndex]}`} target="_blank"><PersonalIdentifier identifier={val} /></a></td>
                                                            )
                                                        } else if (header[idx] === "mrn") {
                                                            return (
                                                                <td><PersonalIdentifier identifier={val} /></td>
                                                            )
                                                        } else {
                                                            return (
                                                                <td>{val}</td>
                                                            )
                                                        }
                                                    })
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </div>

                        <Pagination>
                            <Pagination.First onClick={() => setActivePageNumber(1)} />
                            <Pagination.Prev onClick={() => setActivePageNumber(Math.max(1, activePageNumber - 1))} />

                            {
                                totalPages < 6 ? (
                                    <>
                                        {
                                            range(1, totalPages + 1, 1).map((idx: number) => (
                                                <Pagination.Item key={idx} onClick={() => pageUpdate(idx)}>{idx}</Pagination.Item>
                                            ))
                                        }
                                    </>
                                ) : (
                                    <>
                                        {
                                            activePageNumber - 4 > 1 && (
                                                <Pagination.Ellipsis />
                                            )
                                        }
                                        {
                                            range(Math.max(1, activePageNumber - 4), Math.min(totalPages, activePageNumber + 5), 1).map((idx: number) => {
                                                if (idx === activePageNumber) 
                                                    return <Pagination.Item key={idx} active onClick={() => pageUpdate(idx)}>{idx}</Pagination.Item>
                                                else
                                                    return <Pagination.Item key={idx} onClick={() => pageUpdate(idx)}>{idx}</Pagination.Item>
                                            })
                                        }
                                        {
                                            activePageNumber + 5 < totalPages + 1 && (
                                                <Pagination.Ellipsis />
                                            )
                                        }
                                    </>

                                )
                            }
                            <Pagination.Next onClick={() => pageUpdate(Math.min(totalPages, activePageNumber + 1))} />
                            <Pagination.Last onClick={() => pageUpdate(Math.max(totalPages, 1))} />
                        </Pagination>
                    </Container>
                ) : isLoading ? (
                    <Container fluid style={{paddingTop: '100px', textAlign: 'center'}}>
                        <Row>
                            <Col md={12}>
                                <h1 style={{color: '#AAA', fontSize: '16px'}}><FontAwesomeIcon spin icon={faSpinner} /> Loading...</h1>
                            </Col>
                        </Row>
                    </Container>
                ) : error ? (
                    <Container fluid style={{paddingTop: '100px', textAlign: 'center'}}>
                        <Row>
                            <Col md={12}>
                                <Alert variant="danger">
                                    {error}
                                </Alert>
                            </Col>
                        </Row>
                    </Container>
                ) : (
                    <Container fluid style={{paddingTop: '26px', textAlign: 'center'}}>
                        <Row>
                            <Col md={12}>
                                <h1 style={{color: '#AAA', fontSize: '124px'}}><FontAwesomeIcon icon={faRocket} /></h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <h1 style={{color: '#AAA', fontSize: '15px'}}>No patient visits found matching criteria</h1>
                            </Col>
                        </Row>
                    </Container>
                )
            }
            <Container>
                {
                    !isLoading && sql && (
                        <Row>
                            <Col>
                                <div style={{marginTop: '12px'}}>
                                    <div className="codeheader">Generated SQL</div>
                                    <div className="codebox">
                                        <pre><code data-language="css">
                                            {
                                                sql
                                            }
                                        </code></pre>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )
                }
            </Container>
        </>
    );
};
